export const tabContainerSx = (theme) => ({
  bgcolor: theme.palette.background.default,
  width: '100%',
  height: '44px',
  position: 'fixed',
  zIndex: 100,
});

export const tabListSx = (theme) => ({
  minHeight: '44px',
  padding: '0px 16px',
  position: 'fixed',
  '.MuiTabs-indicator': {
    backgroundColor: theme.palette.tertiary.main,
  },
});

export const tabSx = (theme) => ({
  color: theme.palette.secondary.main,
  textTransform: 'capitalize',
  minHeight: '40px',
  padding: '12px 0',
  marginRight: '32px',
  minWidth: 'inherit',
});
